(function(){
  'use strict';
  angular.module('irricrops')
    .directive('irriSidenav', function() {
      return {
        restrict     : 'E',
        templateUrl  : 'shared/sidenav/sidenav.tmpl.html',
        controllerAs : 'sn',
        controller   : ['$scope', 'CONSTANTES', 'global', 'menu' , '$state','$stateParams', '$mdSidenav', '$q',
        function($scope, CONSTANTES, global, menu, $state, $stateParams, $mdSidenav, $q){
          var vm = this;
          vm.CONSTANTES          = CONSTANTES;
          vm.global              = global;
          vm.selectedVina        = null;
          vm.selectedVinaTemp    = null;
          vm.global.selectedVina = vm.selectedVina;
          vm.searchText          = "";

          vm.confScroll          = {
                axis          : 'y',   // Vertical or horizontal scrollbar? ( x || y ).
                wheel         : true,  // Enable or disable the mousewheel;
                wheelSpeed    : 40,    // How many pixels must the mouswheel scroll at a time.
                wheelLock     : true,  // Lock default scrolling window when there is no more content.
                scrollInvert  : false, // Enable invert style scrolling
                trackSize     : false, // Set the size of the scrollbar to auto or a fixed number.
                thumbSize     : false, // Set the size of the thumb to auto or a fixed number.
                alwaysVisible : false, // Set to false to hide the scrollbar if not being used
                autoUpdate    : true   // Autoupdate the scrollbar if DOM changes. Needs MutationObserver or a polyfill to be available
            };


          function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(vina) {
              var r = (angular.lowercase(vina.nombre).indexOf(lowercaseQuery) >= 0);
              return r;
            };
          }

          vm.querySearch = function(query) {
            return query ? vm.vinas.filter(createFilterFor(query) ):vm.vinas;
          }


          //funcion para mostrar el sidebar
          //obtiene la promise desde el factory MENU
          //al terminar la promesa, asigna los valores a las viñas y
          //asigna por defecto la primera viña seleccionada
          var mostrarSidebar = function(){
            vm.loading = true;
            var prom = menu.getSidebarProm();
            prom.then(function(d){
              vm.loading             = false;
              vm.vinas               = d.data.data.vinas; //vm.datos.data.vinas;
              prepareVinas(vm.vinas);
              vm.selectedVina        = vm.vinas[0];
              vm.selectedVinaTemp    = vm.vinas[0];
              vm.global.selectedVina = vm.vinas[0];
              var vinaSelected       = searchVina();
              if (vinaSelected !== null) {
                vm.selectedVina        = vinaSelected;
                vm.selectedVinaTemp    = vinaSelected;
                vm.global.selectedVina = vinaSelected;
              }
            });
          };


          var prepareVinas = function(vinas){
            var newVinas = [];
            if(vinas.length == 1){
              _.each(vinas, function(vina){
                _.each(vina.vinedos, function(vinedo){
                  var i =  _.findIndex(newVinas, ['id', vinedo.vina_id])
                  if(i == -1){
                    newVinas.push({
                      id: vinedo.vina_id,
                      nombre: vinedo.vina_nombre,
                      vinedos:[]
                    });
                    i = newVinas.length - 1;
                  }
                  newVinas[i].vinedos.push(vinedo);
                })
              })
              //console.table(newVinas);
              vm.vinas = newVinas;
            }
          }


          vm.changeVina = function (vina) {
            if(vina === null || vina === undefined){
              return false;
            }
            if(vina.vinedos.length  == 1){
              var isMobile = global.responsiveIs("xs, sm");
              if(isMobile){
                $state.go(CONSTANTES.INITIAL_MOBILE_STATE,{id: vina.vinedos[0].id});
                console.log("sidenav.js redirect mobile");
              }else{
                $state.go(CONSTANTES.INITIAL_STATE,{id: vina.vinedos[0].id});
                console.log("sidenav.js redirect");
              }
            }

            vm.selectedVina = vina;
            vm.selectedVinaTemp = vina;
            vm.global.selectedVina = vina;
            Raven.setTagsContext({
              vina: global.selectedVina.nombre
            });
          };


          vm.hideSidenav = function() {
            $mdSidenav('left').close();
          }


          //cuando el factory MENU obtiene la informacion del /me este
          //descarga la informacion de sidebar
          //al obtener esta informacion, la funcion showSidebar() devuelve
          //true, para poder mostrar el sidebar
          $scope.$watch(function(){
            return menu.showSidebar();
          }, function(n, o){
            //si cambio de false a true
            if(n && !o){
              mostrarSidebar();
            }
          });



          var searchVina = function() {
            var parentState = $state.current.name.split(".")[0];
            var vinaSelected= null;
            angular.forEach(vm.vinas, function(vina) {
              angular.forEach(vina.vinedos, function(vinedo) {
                if ( parentState == "vinedo") {
                  if (vinedo.id == $stateParams.id) {
                    vinaSelected = vina;
                  }
                }else{
                  angular.forEach(vinedo.equipos, function(equipo) {
                    if (parentState == "equipo") {
                      if (equipo.id == $stateParams.id) {
                        vinaSelected = vina;
                      }
                    }else{
                      angular.forEach(equipo.sectores_riego, function(sector) {
                        if (parentState == "cuartel" && sector.id == $stateParams.id) {
                          vinaSelected = vina;
                        }
                      });
                    }
                  });
                }
              });
            });
            if (vinaSelected === null && vm.vinas.length > 0){
              vinaSelected = vm.vinas[0];
            }

            return vinaSelected;
          };


        }]

      };

    });
})();
